import React from "react";
const AuthContext = React.createContext({
    authenticated: false,

    user:null,
    token:null,
    services:null,
    handleServiceList:()=>{},
    login: () => {},
    logout:()=>{},

});
export default AuthContext;